import React from 'react';
import {  AppBar,Container, Box,IconButton, Typography, Button, Stack } from '@mui/material';
import {Logout} from '@mui/icons-material'
import { useNavigate } from 'react-router-dom';
import paths from '../../routes/paths'
import unifiedLogout from '../../utils/unifiedLogout'

export default function AdvConversationSuccess() {
  const navigate = useNavigate();
  const staffData = JSON.parse(localStorage.getItem('selectedStaff') || '{}');  
  const handleGoHome = () => {
    navigate(paths.pupilSurveys);
  };
  const safeSpaceConfig = JSON.parse(localStorage.getItem('safeSpaceConfig'));
  const autoResponceMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 0);
  const autoResponceMessageContent = autoResponceMessage?.messageContent;

  return (
    <>
     <AppBar className="header">
        <Container maxWidth="xxl">
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
        >
            <div className="logo">
            <span>Welbee</span>
            </div>
            <div>
            <nav>
                <IconButton
                onClick={() => {
                    unifiedLogout()
                }}
                >
                <Logout sx={{color: '#fff', fontSize: 28}} />
                </IconButton>
            </nav>
            </div>
        </Stack>
        </Container>
    </AppBar>
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box
        sx={{
          p: 4,
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 3,
          textAlign: 'left',
          width: '100%',
        }}
      >
        <Typography variant="h4" gutterBottom>
          Message Sent!
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          {autoResponceMessageContent && autoResponceMessageContent.trim() !== ''
            ? autoResponceMessageContent.replace(/\[Adult Name\]/gi, staffData?.staffName || '')
            : `${staffData?.staffName || ''} has been sent your message and will get back to you soon.`}
        </Typography>
        <Stack direction="row" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleGoHome}
          >
            Home
          </Button>
        </Stack>
      </Box>
    </Container>
    </>
  );
}